module.exports = __webpack_public_path__ + "img/1352711575.53437e95.jpg";